import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Ban, Plus, ShieldOff } from 'lucide-react';

export const BlocklistTab = ({ blockedVisitors, onBlockVisitor, onUnblock }) => {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ vehicle_number: '', phone: '', reason: '' });

  const handleSubmit = () => {
    if (!form.vehicle_number && !form.phone) {
      toast.error('Provide at least a vehicle number or phone');
      return;
    }
    onBlockVisitor(form.vehicle_number, form.phone, form.reason);
    setForm({ vehicle_number: '', phone: '', reason: '' });
    setShowForm(false);
  };

  return (
    <div className="space-y-6">
      <div className="p-6 border" style={{ backgroundColor: '#FFFFFF', borderColor: '#E4E4E7' }}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold" style={{ fontFamily: 'Cabinet Grotesk, sans-serif', color: '#09090B' }}>
            Blocked Visitors
          </h2>
          <Button
            onClick={() => setShowForm(!showForm)}
            data-testid="add-block-btn"
            size="sm"
            style={{ backgroundColor: '#DC2626', color: '#FFFFFF', fontFamily: 'Cabinet Grotesk, sans-serif', fontWeight: 'bold' }}
          >
            <Plus size={14} className="mr-1" /> Block Visitor
          </Button>
        </div>

        {showForm && (
          <div className="p-4 mb-4 border" style={{ backgroundColor: '#FEF2F2', borderColor: '#FECACA' }} data-testid="block-form">
            <p className="text-sm font-bold mb-3" style={{ fontFamily: 'IBM Plex Sans, sans-serif', color: '#991B1B' }}>
              Block a visitor by vehicle number, phone, or both
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
              <div>
                <Label style={{ fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '12px' }}>Vehicle Number</Label>
                <Input placeholder="e.g. DL01AB1234" value={form.vehicle_number} onChange={(e) => setForm({ ...form, vehicle_number: e.target.value })} data-testid="block-vehicle-input" className="mt-1" />
              </div>
              <div>
                <Label style={{ fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '12px' }}>Phone Number</Label>
                <Input placeholder="e.g. 9876543210" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="block-phone-input" className="mt-1" />
              </div>
              <div>
                <Label style={{ fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '12px' }}>Reason</Label>
                <Input placeholder="e.g. Public nuisance" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="block-reason-input" className="mt-1" />
              </div>
            </div>
            <div className="flex gap-2">
              <Button onClick={handleSubmit} data-testid="confirm-block-btn" size="sm" style={{ backgroundColor: '#DC2626', color: '#FFFFFF', fontFamily: 'Cabinet Grotesk, sans-serif', fontWeight: 'bold' }}>
                Confirm Block
              </Button>
              <Button variant="outline" size="sm" onClick={() => setShowForm(false)} style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                Cancel
              </Button>
            </div>
          </div>
        )}

        {blockedVisitors.length === 0 ? (
          <div className="text-center py-8">
            <ShieldOff size={40} style={{ color: '#D4D4D8', margin: '0 auto 12px' }} />
            <p style={{ fontFamily: 'IBM Plex Sans, sans-serif', color: '#71717A' }}>No blocked visitors. Your society is safe!</p>
          </div>
        ) : (
          <div className="space-y-3">
            {blockedVisitors.map((bv) => (
              <div key={bv.id} className="flex items-center justify-between p-4 border" style={{ borderColor: '#FECACA', backgroundColor: '#FEF2F2' }} data-testid={`blocked-item-${bv.id}`}>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center" style={{ backgroundColor: '#DC2626' }}>
                    <Ban size={18} style={{ color: '#FFFFFF' }} />
                  </div>
                  <div>
                    <div className="flex items-center gap-3">
                      {bv.vehicle_number && <span className="text-sm font-bold" style={{ fontFamily: 'JetBrains Mono, monospace', color: '#09090B' }}>{bv.vehicle_number}</span>}
                      {bv.phone && <span className="text-sm" style={{ fontFamily: 'JetBrains Mono, monospace', color: '#71717A' }}>{bv.phone}</span>}
                    </div>
                    <p className="text-xs mt-1" style={{ fontFamily: 'IBM Plex Sans, sans-serif', color: '#991B1B' }}>
                      {bv.reason || 'No reason provided'} &middot; {new Date(bv.blocked_at).toLocaleDateString()}
                    </p>
                  </div>
                </div>
                <Button variant="outline" size="sm" onClick={() => onUnblock(bv.id)} data-testid={`unblock-btn-${bv.id}`} style={{ borderColor: '#10B981', color: '#059669', fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '12px' }}>
                  Unblock
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
